import React from "react";

const MoodScale = ({ value, onChange, disabled = false }) => {
  const moods = [
    { value: 1, label: "OFF", emoji: "😴" },
    { value: 2, label: "Low", emoji: "😔" },
    { value: 3, label: "Okay", emoji: "😐" },
    { value: 4, label: "On", emoji: "🙂" },
    { value: 5, label: "ONNN", emoji: "😊" }
  ];

  return (
    <div className="flex items-center justify-between gap-2">
      {moods.map((mood) => (
        <button
          key={mood.value}
          onClick={() => !disabled && onChange(mood.value)}
          disabled={disabled}
          className={`flex-1 flex flex-col items-center py-3 rounded-xl transition-all ${
            value === mood.value
              ? "bg-[#0B3D2E] text-white scale-105"
              : disabled
              ? "bg-[#F9F9F7] text-[#8FA39B] opacity-50"
              : "bg-[#F9F9F7] text-[#4A5D56] hover:bg-[#E3EBE5]"
          }`}
          data-testid={`mood-${mood.value}`}
        >
          <span className="text-2xl mb-1">{mood.emoji}</span>
          <span className="text-[10px] font-medium">{mood.label}</span>
        </button>
      ))}
    </div>
  );
};

export default MoodScale;
